export default __webpack_public_path__ + "static/media/AG17.1a0c2938.mp3";